import './NumberFilterView.less';
import React from "react";
import {formatNumberLocalized} from "../../../../utils/number";
import FilterViewTemplate from "../../templates/filter-view/FilterViewTemplate";
import {translate} from "../../../../i18n";

export default class NumberFilterView extends React.Component {

    isRangeInput = (operator) => {
        return ['in_range'].includes(operator);
    };

    isListInput = (operator) => {
        return ['in_list'].includes(operator);
    };

    isSelectInput = (operator) => {
        /** @type {LabelMap} */
        const vSelectableOptions = this.props.vSelectableOptions;

        return ['is'].includes(operator) && !!vSelectableOptions;
    };

    render() {
        const {fieldName, operator, value, requestEdit, optPrefix, optSuffix, optFormatDisabled, vDecimalDigits} = this.props;
        /** @type {LabelMap} */
        const vSelectableOptions = this.props.vSelectableOptions;

        const decorate = (number) => number === null ? ''
            : (optPrefix !== undefined ? optPrefix : '')
            + (optFormatDisabled ? number : formatNumberLocalized(number, vDecimalDigits !== undefined ? vDecimalDigits : 0))
            + (optSuffix !== undefined ? optSuffix : '');

        const decoratedValue = this.isSelectInput(operator)
            ? (vSelectableOptions.get(value) ? vSelectableOptions.get(value).label : '')
            : (
                this.isRangeInput(operator)
                    ? value.map(v => decorate(v)).join(' ... ')
                    : (
                        this.isListInput(operator)
                            ? value.map(v => decorate(v)).join(', ')
                            : decorate(value)
                    )
            );

        const isEmpty = value === null;

        return <div
            className={
                'number-filter-view'
                + (isEmpty ? ' is-empty' : '')
            }
        >
            <FilterViewTemplate
                fieldName={fieldName}
                operator={operator}
                value={!isEmpty ? decoratedValue : translate('(empty)')}
                valueLabel={!isEmpty ? decoratedValue : undefined}
                requestEdit={requestEdit}
            />
        </div>;
    }
}
